import React from 'react'
import { connect } from 'react-redux'
import { Button } from '@material-ui/core'
import { openEdicionCalleCamionCaladoDialog } from '../../actions'

function EdicionCalleCamionCalado (props) {
  const handleOpen = () => { props.openEdicionCalleCamionCaladoDialog() }

  return (
    <Button
      className='btn-reporte-egreso-qr'
      style={{ margin: '2px auto' }}
      color='primary'
      onClick={handleOpen}
      type='button'
      size='small'
      variant='contained'
    >
      Editar camion
    </Button>
  )
}

const mapActionsToProps = {
  openEdicionCalleCamionCaladoDialog
}

export default (connect(null, mapActionsToProps)(EdicionCalleCamionCalado))
